// extracted by mini-css-extract-plugin
module.exports = {"summaryDetails":"InvoiceSummaryDetails_summaryDetails__2P99C"};